import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { TABLE_CELL_DATA } from '../../../../../../../osp-ui/components/data/table/table.constant';
import { TableCellData } from '../../../../../../../osp-ui/components/data/table/contract/table-cell-data.contract';
import { TableCellBase } from '../../../../../../../osp-ui/components/data/table/directives/table-cell-base.directive';
import { LanguageService } from '../../../../../../../core/services/language.service';
import { LocationType } from '../../../../../../../shared/enums/location-type.enum';
import { IconKey } from '../../../../../../../../whitelabel/icon-key.enum';
import { IconProviderService } from '../../../../../../../whitelabel/services/icon-provider.service';

@Component({
  selector: 'osp-active-location-type-cell',
  standalone: true,
  templateUrl: './active-location-type-cell.component.html',
  styleUrl: './active-location-type-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveLocationTypeCellComponent extends TableCellBase<LocationType> implements OnInit {
  protected icon = '';
  protected label = '';

  constructor(
    @Inject(TABLE_CELL_DATA) data: TableCellData,
    private readonly languageService: LanguageService,
    private readonly iconProviderService: IconProviderService,
  ) {
    super(data);
  }

  ngOnInit(): void {
    if (this.value === LocationType.STOCK) {
      this.icon = this.iconProviderService.getIcon(IconKey.EquipmentCreateStock);
      this.label = this.translate('shared.pipes.equipmentLocationType.stock');
      return;
    }

    this.icon = this.iconProviderService.getIcon(IconKey.SidebarLocations);
    this.label = this.translate('shared.pipes.equipmentLocationType.project');
  }

  private translate(key: string): string {
    return this.languageService.getInstant(key);
  }
}
